
import React, { useState, useEffect, useMemo, Fragment, useRef } from "react";
import { Helmet } from "react-helmet";
import AddrPopup from "@components/AddrPopup";
import { comma, getAddress } from '@src/util/helper'
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import LoadScript from "@util/loadScript";
import { createOrder, fakeOrder, validate } from "@pages/common/common";
import { emailRegex } from "@util/helper";
import { showSnackbar } from "@context/SnackbarContext";

import {
  Grid,
  Divider,
  Typography,
  useMediaQuery,
  useTheme,
  Container,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Radio,
  Button,
  Checkbox,
  RadioGroup,
  IconButton,
} from '@mui/material'
import useIndicator from '@hooks/useIndicator'
import moment from "moment";
import ContractDownloader from "@components/ContractDownloader";
import FileDownloadOutlined from '@mui/icons-material/FileDownloadOutlined'
import ConfirmDialog from '@components/ConfirmDialog'

const Error = () => {
  return(
    <div>
      <div>에러가 발생했습니다.</div>
      <div>잠시 후 다시 시도해 주시기 바랍니다.</div>
    </div>
  )
}

export default Error
